import React from "react";
import "./About.css";
import aboutImg from "./img/about.jpg";

function About() {
  // UP TO TOP BTN
  window.addEventListener("scroll", function () {
    const upToTop = document.querySelector("a.bottom__to__top");
    upToTop.classList.toggle("active", window.scrollY > 0);
  });
  return (
    <div className="about component__space" id="About">
      <div className="container">
        <div className="row">
          <div className="col__2">
            <img src={aboutImg} alt="" className="about__img" />
          </div>
          <div className="col__2">
            <h1 className="about__heading">About Me.</h1>
            <div className="about__meta">
              <p className="about__text p__color">
                {/* Welcome to my portfolio! <strong>I'm Baraka Ganai</strong>, a
                passionate and dedicated{" "}
                <strong>FULL STACK WEB DEVELOPER.</strong> I thrive on
                transforming ideas into innovative and functional websites that
                leave a lasting impression. <br />
                <br /> Throughout my career, I've honed my skills in front-end
                development, back-end programming, and UI/UX design. I have a
                strong knowledge of{" "}
                <strong>
                  {" "}
                  HTML, CSS, JavaScript, Node, MongoDB and counting...
                </strong>{" "}
                allowing me to create visually stunning and interactive
                websites. I'm also proficient in frameworks such as{" "}
                <strong>REACT</strong> which enable me to develop dynamic and
                responsive web applications. */}
                Experienced and innovative Senior Full-Stack Web Developer with
                3+ years of hands-on expertise in designing, developing, and
                deploying robust web applications. Proficient in both front-end
                and back-end technologies, adept at translating complex
                requirements into elegant, scalable solutions. Proven track
                record of leading cross-functional teams and delivering projects
                on time and within budget.
                <br />
                <br />I have a strong knowledge of{" "}
                <strong>
                  {" "}
                  HTML, CSS, JavaScript, TypeScript, Node Js, MySQL, MongoDB and
                  counting...
                </strong>{" "}
                allowing me to create visually stunning and interactive
                websites. I'm also proficient in frameworks such as{" "}
                <strong>
                  Next js, React js, TailwindCss, Bootstrap and Express js
                </strong>{" "}
                which enable me to develop dynamic and responsive web
                applications.
              </p>
            </div>
          </div>
        </div>
        {/* {UP TO TOP BTN} */}
        <div className="up__to__top__btn">
          <a href="#top" className="bottom__to__top">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-chevron-up white"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
}
export default About;
